export enum BillSource {
  ALL = 'all',
  SUBSCRIPTIONS = 'subscriptions',
  FEE_FOR_SERVICE_EVENTS = 'fee_for_service_events',
  ADMIN_FEE_CLAIMS = 'admin_fee_claims',
}

export enum BillDetailsKey {
  COST_SHARE = 'costShare',
}
